import { useQueryClient } from "@tanstack/react-query";
import useCurrentUser from "../../hooks/local-storage/use-current-user";
import { useGetFutureAppointment } from "../../queries/use-future-appointment";
import { getXtenantId } from "../../utils/utils";

interface TriggerAppointment {
  triggerFutureAppEvent: () => void;
  futureAppointmentDetail: any;
}

/**
 * @description Subscribes to the provider's next future appointment.
 *   Anything in the app that invalidates `["future-appointment"]` will
 *   cause this hook to refetch and consumers to re-arm their reminder.
 *
 * @author Rajkumar Rathod
 */
export const useTriggerAppointmentReminder = (): TriggerAppointment => {
  const [user] = useCurrentUser();
  const providerId = user?.uuid ?? "";
  const xTENANTID = getXtenantId();
  const queryClient = useQueryClient();

  const { data: futureAppointment } = useGetFutureAppointment({
    providerId,
    xTENANTID: xTENANTID ?? undefined,
    disabled: false,
  });

  const triggerFutureAppEvent = () => {
    queryClient.invalidateQueries({ queryKey: ["future-appointment"] });
  };

  return {
    triggerFutureAppEvent,
    futureAppointmentDetail: futureAppointment?.data ?? null,
  };
};
